import { FaUserCircle } from 'react-icons/fa'
import { useCallback, useEffect, useState } from 'react'

import styles from './aluno.module.css'

import { useAuth } from '../hooks/useAuth'
import { Aluno } from '../domain/entities/aluno.entity'
import { AlunoRepository } from './admin/repositories/aluno.repository'
import { Document } from '@/domain/entities/document.entity'
import { useDownload } from './@hooks/use-download'
import { StorageService } from '@/services/storage'

const storageService = new StorageService()

export function AlunoPerfilPage() {
  const { student: studentToken, token, signOut } = useAuth()
  const [documentos, setDocumentos] = useState<Document[]>([])
  const [editing, setEditing] = useState(false)
  const [student, setStudent] = useState<Aluno>({} as Aluno)
  const { download } = useDownload({ storageService })

  const openFile = async (src: string) => {
    const [{ url }] = await download(src)
    return url
  }

  const fetchStudent = useCallback(async () => {
    if (!token || !studentToken) return
    const _student = await AlunoRepository.GetInstance().findById(token)
    setStudent(_student)
  }, [token, studentToken])

  const fetchDocuments = useCallback(async () => {
    if (!token || !studentToken) return
    const documentos = await AlunoRepository.GetInstance().documentos(token)
    setDocumentos(documentos)
  }, [token, studentToken])

  useEffect(() => {
    fetchDocuments()
    fetchStudent()
  }, [fetchStudent, fetchDocuments])

  async function handleUpdate() {
    setEditing(false)
    const _student = await AlunoRepository.GetInstance().atualizar({
      responsavelemail: student.responsavelemail,
      responsaveltelefone: student.responsaveltelefone,
      responsaveltelefone2: student.responsaveltelefone2,
    })
    setStudent(_student)
  }

  return (
    <div className={styles.mainContainer}>
      <div className={styles.background}>
        {editing && (
          <div>
            <button onClick={() => setEditing(false)}>Cancelar</button>
            <button onClick={handleUpdate}>Atualizar</button>
          </div>
        )}

        {editing && <button onClick={() => setEditing(true)}>Editar</button>}

        <FaUserCircle />

        <h3>{student.alunonome}</h3>

        <div className={styles.row}>
          <p>CPF do aluno: </p>
          <p>{student.alunocpf}</p>
        </div>

        <div className={styles.line} />

        <div className={styles.row}>
          <p>CPF PersonResponsible:</p>
          <p>{student.responsavelcpf}</p>
        </div>

        {editing && (
          <>
            <div className={styles.row}>
              <p>EMAIL Responsável: </p>
              <input
                value={student.responsavelemail}
                onChange={(e) =>
                  setStudent((state) => ({
                    ...state,
                    responsavelemail: e.target.value,
                  }))
                }
              />
            </div>

            <div className={styles.row}>
              <p>TELEFONE Responsável: </p>
              <input
                value={student.responsaveltelefone}
                onChange={(e) =>
                  setStudent((state) => ({
                    ...state,
                    responsaveltelefone: e.target.value,
                  }))
                }
              />
            </div>
            <div className={styles.row}>
              <p>TELEFONE 2 PersonResponsible:</p>
              <input
                value={student.responsaveltelefone2}
                onChange={(e) =>
                  setStudent((state) => ({
                    ...state,
                    responsaveltelefone2: e.target.value,
                  }))
                }
              />
            </div>
          </>
        )}

        {!editing && (
          <>
            <div className={styles.row}>
              <p>EMAIL PersonResponsible: </p>
              <p>{student.responsavelemail}</p>
            </div>
            <div className={styles.row}>
              <p>TELEFONE PersonResponsible: </p>
              <p>{student.responsaveltelefone2}</p>
            </div>
            <div className={styles.row}>
              <p>TELEFONE 2 PersonResponsible: </p>
              <p>{student.responsaveltelefone2}</p>
            </div>
          </>
        )}

        <div className={styles.documentsContainer}>
          {documentos?.length > 0 &&
            documentos?.map((doc) => (
              <p>
                {doc.type} -{' '}
                <div onClick={() => openFile(doc.filename)}>{doc.filename}</div>
              </p>
            ))}

          {documentos?.length === 0 && <p>Nao ha documentos</p>}

          <a className={styles.FakeButton} href={'/'} onClick={signOut}>
            Logout
          </a>
        </div>
      </div>
    </div>
  )
}
